module.exports = __webpack_public_path__ + "img/cm.377f22f3.svg";